import { __assign, __awaiter, __generator } from "tslib";
import { genAxiosClient, genHaloConfig } from "@smartsheet/http-client";
import { Griddle } from "./Griddle";
import { GridServiceApiVersion } from "./models";
export var axiosClient = genAxiosClient();
export var GridServiceApiV2 = {
    gridInfo: function (gridId) { return "/grids/" + gridId + "/info"; },
    rowStructure: function (gridId) { return "/grids/" + gridId + "/filteredAndSortedRowStructure"; },
    rowRange: function (gridId) { return "/grids/" + gridId + "/rowRange"; },
    rows: function (gridId) { return "/grids/" + gridId + "/rows"; },
    columns: function (gridId) { return "/grids/" + gridId + "/columns"; },
    columnOptions: function (gridId, columnId, offset) {
        return "/grids/" + gridId + "/columns/" + columnId + "/columnOptions?offset=" + (offset || 1);
    }
};
export var GridServiceApiV2Alpha = {
// add alpha endpoints as needed
};
export var GridServiceApi = __assign(__assign({}, GridServiceApiV2), GridServiceApiV2Alpha);
var GridPlatformDataClient = /** @class */ (function () {
    function GridPlatformDataClient() {
    }
    GridPlatformDataClient.prototype.get = function (url, params) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axiosClient.get(Griddle.config.gridServiceHosts.get(GridServiceApiVersion.V2) + url, genHaloConfig({ params: params }))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    GridPlatformDataClient.prototype.post = function (url, body, params) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axiosClient.post(Griddle.config.gridServiceHosts.get(GridServiceApiVersion.V2) + url, body, genHaloConfig({ params: params }))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return GridPlatformDataClient;
}());
export { GridPlatformDataClient };
var GridPlatformDataClientAlpha = /** @class */ (function () {
    function GridPlatformDataClientAlpha() {
    }
    GridPlatformDataClientAlpha.prototype.get = function (url, params) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axiosClient.get(Griddle.config.gridServiceHosts.get(GridServiceApiVersion.V2_ALPHA) + url, genHaloConfig({ params: params }))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    GridPlatformDataClientAlpha.prototype.post = function (url, body) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axiosClient.post(Griddle.config.gridServiceHosts.get(GridServiceApiVersion.V2_ALPHA) + url, body, genHaloConfig())];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return GridPlatformDataClientAlpha;
}());
export { GridPlatformDataClientAlpha };
//# sourceMappingURL=GriddleDataClient.js.map